var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "border" },
    [
      _c(
        "h2",
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Create Client Contact")]),
              _vm.showAlert
                ? _c("Alert", {
                    staticClass: "mx-4 my-2",
                    attrs: { text: "Contact created!", type: "success" },
                  })
                : _vm._e(),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-form",
        [
          _c(
            "v-container",
            { staticClass: "pt-4 px-8" },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Name", required: "" },
                        model: {
                          value: _vm.newContact.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.newContact, "name", $$v)
                          },
                          expression: "newContact.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Email", required: "" },
                        model: {
                          value: _vm.newContact.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.newContact, "email", $$v)
                          },
                          expression: "newContact.email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Phone Number", required: "" },
                        model: {
                          value: _vm.newContact.phone_number,
                          callback: function ($$v) {
                            _vm.$set(_vm.newContact, "phone_number", $$v)
                          },
                          expression: "newContact.phone_number",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Description" },
                        model: {
                          value: _vm.newContact.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.newContact, "description", $$v)
                          },
                          expression: "newContact.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Role" },
                        model: {
                          value: _vm.newContact.role,
                          callback: function ($$v) {
                            _vm.$set(_vm.newContact, "role", $$v)
                          },
                          expression: "newContact.role",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _vm.creating
                        ? _c("v-progress-circular", {
                            staticClass: "px-8",
                            attrs: { indeterminate: "" },
                          })
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          staticClass: "float-sm-right mt-2 mx-2",
                          attrs: { small: "" },
                          on: { click: _vm.createClientContact },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("mdi-plus-box-outline"),
                          ]),
                          _vm._v(" Create "),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "float-sm-right mt-2",
                          attrs: { small: "" },
                          on: { click: _vm.cancelCreate },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("mdi-cancel"),
                          ]),
                          _vm._v(" Cancel "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }